module.exports = __webpack_public_path__ + "static/img/xaizai.892dd56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xaizai.png
// module id = FunJ
// module chunks = 2